import { useState, useEffect } from 'react';
import { useStatesData } from '../../context/StatesContext';
import Map from './Map';
import InfoCarrousel from './InfoCarrousel';
import InfoBasic from './InfoBasic';
import Loading from '../Loading';
import useWindowDimensions from '../../hooks/useWindowDimensions';

const MapDashboard = () => {
  const { width: windowWidth } = useWindowDimensions();
  const [currentState, setCurrentState] = useState();
  const [currentStateData, setCurrentStateData] = useState([]);
  const [filter, setFilter] = useState({
    primera: true,
    segunda: true,
    tercera: true
  });
  const { states: statesData, sedes } = useStatesData();
  const [popup, setPopup] = useState(false);

  const filterStages = e => {
    const stage = e.target.id;
    setFilter(prev => {
      if (stage === 'primera') return { ...prev, primera: true, segunda: false, tercera: false };
      if (stage === 'segunda') return { ...prev, primera: false, segunda: true, tercera: false };
      if (stage === 'tercera') return { ...prev, primera: false, segunda: false, tercera: true };
      if (stage === 'reset') return { ...prev, primera: true, segunda: true, tercera: true };
    });
    window.simplemaps_countrymap.zoom_level !== 'out' && window.simplemaps_countrymap.load();
  };

  const handleRegresar = () => {
    setCurrentState(null); // ✅ Limpiar estado seleccionado
    setCurrentStateData([]); // ✅ Limpiar datos del carrusel
    filterStages({ target: { id: 'reset' } }); // ✅ Resetear filtros
  };

  useEffect(() => {
    const getStateData = () => {
      const state = statesData.find(state => state.code === currentState);
      const infoCats = [
        // 'Armonización Legislativa',
        // 'Modificación de Estatutos',
        'Oficinas de CFCRL',
        'Centros de conciliación locales',
        'Tribunales laborales federales',
        'Tribunales laborales locales',
        // 'Subsidios'
      ];
      const stateInfo = infoCats.map(cat => ({ title: cat, ...state }));
      setCurrentStateData(stateInfo);
    };
    statesData.length && currentState && getStateData();
  }, [currentState, statesData]);

  return (
    <div className='map-container container-fluid pt-5 pb-3'>
      <div className={`row mb-3 banner text-center ${currentState ? 'vanish' : ''}`}>
        <h2 className='title front'>MAPA DE AVANCES</h2>
        <h2 className='subtitle front'>por Entidad Federativa</h2>
      </div>
      <div className='row justify-content-center'>
        <div className={popup && windowWidth < 768 ? 'col-md-6 front' : 'col-md-6'}>
          {statesData.length ? (
            <Map
              statesData={statesData}
              sedes={sedes}
              setCurrentState={setCurrentState}
              filter={filter}
              setPopup={setPopup}
            />
          ) : (
            <Loading />
          )}
        </div>
        <div className={popup && windowWidth < 768 ? 'col-md-6' : 'col-md-6 front'}>
          {currentState && currentStateData.length ? (
            <>
              <InfoCarrousel data={currentStateData} />
              <div className='row align-items-center justify-content-center mt-3'>
                <div className='col-4 text-center'>
                  <button
                    className='btn regresar mx-auto'
                    onClick={handleRegresar}
                    style={{ fontWeight: '500' }}
                  >
                    REGRESAR
                  </button>
                </div>
              </div>
            </>
          ) : (
            <InfoBasic filterStages={filterStages} />
          )}
        </div>
      </div>
      <div className='row'>
        <div className='col-12'>
          <div style={{ 
            fontSize: '11px', 
            lineHeight: '1.6',
            color: '#333',
            textAlign: 'justify',
            padding: '20px 25px',
            borderRadius: '6px',
            // backgroundColor: '#f8f9fa',
            // borderTop: '3px solid #1b271cff',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)'
          }}>
            <p style={{ marginBottom: '', fontWeight: '600' }}>
              Nota sobre las estadísticas:
            </p>
            <p style={{ marginBottom: '' }}>
              Las estadísticas difundidas en el micrositio de la reforma laboral derivan de los registros administrativos correspondientes a los Centros de Conciliación y Tribunales Laborales, tanto federales como locales, los cuales son enviados por dichas autoridades de manera mensual a la Unidad de Enlace para la Reforma al Sistema de Justicia Laboral (UERSJL) de la Secretaría del Trabajo y Previsión Social, a través de los "Formatos de reporte de avances" en cumplimiento a los acuerdos 15-18/10/2021, 12-27/10/2022 y CCIRSJL 09-18/06/2025 aprobados por el Consejo de Coordinación para la Implementación de la Reforma al Sistema de Justicia Laboral.
            </p>
            <p style={{ marginBottom: '' }}>
              Por lo anterior, se aclara que la UERSJL recopila, procesa y reporta la información remitida por estos organismos públicos, con la finalidad de exponer los avances en la consolidación de la reforma al sistema de justicia laboral. Cabe especificar que, en caso de que se detecten modificaciones considerables a las cifras expuestas con anterioridad en el micrositio, se debe a la actualización o aclaración de procesos realizados por las autoridades involucradas.
            </p>
            <p style={{ marginBottom: '0' }}>
              Para dudas o consultas, puede ponerse en contacto a través del correo <strong>reforma.laboral@stps.gob.mx</strong> y número telefónico <strong>55 2000 5300, extensión 63052 o 63202</strong>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapDashboard;